module.exports = __webpack_public_path__ + "static/media/OlderMan.30cd575b.png";